import { createSelector } from '@reduxjs/toolkit'

import type { MissionsState } from './missions.types'

// NOTE: We're intentionally avoiding a direct reference to RootState here to
// break a circular dependency issue. By typing the missionsStateSelector to
// MissionsState, we decouple this selector from the global RootState type.
// This is especially a problem for redux-module hook sagas. This approach
// sacrifices some type safety but keeps the selector usage simple.
// Use with caution and maintain awareness of the risks.
const missionsStateSelector = (state: { missions: MissionsState }) => state.missions

export const autoEnrollSelector = createSelector(
  missionsStateSelector,
  (state) => state.autoEnrollUser,
)

export const selectedRequestSelector = createSelector(
  missionsStateSelector,
  (state) => state.selectedRequest,
)

export const patchRequestTypeSelector = createSelector(
  missionsStateSelector,
  (state) => state.patchRequestType,
)

export const draftRequestSelector = createSelector(
  missionsStateSelector,
  (state) => state.draftRequest,
)

export const showRejectionScreenSelector = createSelector(
  missionsStateSelector,
  (state) => state.showRejectionScreen,
)

export const selectedStatusOptionSelector = createSelector(
  missionsStateSelector,
  (state) => state.selectedStatusOption,
)

export const numberOfMissionsConfigSelector = createSelector(
  missionsStateSelector,
  (state) => state.numberOfMissionsConfig,
)

export const orderBySelector = createSelector(missionsStateSelector, (state) => state.orderBy)

export const shouldShowBeneficiaryIndicatorSelector = createSelector(
  missionsStateSelector,
  (state) => state.shouldShowBeneficiaryIndicator,
)

export const activeMissionTypeSelector = createSelector(
  missionsStateSelector,
  (state) => state.activeMissionType,
)

export const searchQuerySelector = createSelector(
  missionsStateSelector,
  (state) => state.searchQuery,
)
